import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: 'Login',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "login" */ '../pages/Login.vue')
    },
    {
        path: '/forgot-password',
        name: 'ForgotPasswordPage',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "forgot-password" */ '../pages/ForgotPasswordPage')
    },
    {
        path: '/registration',
        name: 'RegistrationFirebase',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "registration-firebase" */ '../pages/RegistrationFirebase.vue')
    },
    {
        path: '/',
        name: 'SocialLogin',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "social_login" */ '../pages/SocialLogin.vue')
    },
    {
        path: '/social-step-two',
        name: 'SocialAuthStepTwo',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "social_step_two" */ '../pages/SocialAuthStepTwo.vue')
    },
    {
        path: '/social-step-three',
        name: 'SocialAuthStepThree',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "social_step_three" */ '../pages/SocialAuthStepThree.vue')
    },
    {
        path: '/events-app',
        name: 'Events',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "events" */ '../pages/Events.vue')
    },
    {
        path: '/events-app/:event_id/details',
        name: 'EventDetails',
        props: true,
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "EventDetails" */ '../pages/EventDetails.vue')
    },
    {
        path: '/events-app/:event_id/meeting-result',
        name: 'MeetingResultsYes',
        props: true,
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "MeetingResultsYes" */ '../pages/MeetingResultsYes.vue')
    },
    {
        path: '/events-app/:event_id/past-details',
        name: 'EventPastDetails',
        props: true,
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "EventPastDetails" */ '../pages/EventPastDetails.vue')
    },
    {
        path: '/mobile-meeting/:event_id/:bearer',
        props: true,
        name: 'EventDetailsMobileUser',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "eventdetailsmobile" */ '../pages/EventDetailsMobileUser.vue')
    },
    {
        path: '/public/users/:uid',
        props: true,
        name: 'PublicUserInfo',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "publicuserinfo" */ '../pages/PublicUserInfo.vue')
    },
    {
        path: '/public/groups/:group_id',
        props: true,
        name: 'PublicGroupInfo',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "publicgroupinfo" */ '../pages/PublicGroupInfo.vue')
    },
    {
        path: '/calendar',
        name: 'Calendar',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "Calendar" */ '../pages/Calendar.vue')
    },
    {
        path: '/friends',
        name: 'Friends',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "Friends" */ '../pages/Friends.vue')
    },
    {
        path: '/profile',
        name: 'Profile',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "Profile" */ '../pages/Profile.vue')
    },
    {
        path: '/profile/:user_id',
        name: 'FriendProfile',
        props: true,
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "FriendProfile" */ '../pages/FriendProfile.vue')
    },
    {
        path: '/edit-profile',
        name: 'EditProfile',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "EditProfile" */ '../pages/EditProfile.vue')
    },
    {
        path: 'public/events/:event_id',
        props: true,
        name: 'PublicEventInfo2',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "publicevent-info" */ '../pages/PublicEventInfo.vue')
    },
    {
        path: '/events',
        name: 'PublicEventsList',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "publiceventslist" */ '../pages/PublicEventsList.vue')
    },
    {
        path: '/:event_id(\\d+)',
        props: true,
        name: 'PublicEventInfo',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "publiceventinfo" */ '../pages/PublicEventInfo.vue')
    },
    {
        path: '*',
        name: 'PageNotFound',
        meta: {transitionName: `slide`},
        component: () => import(/* webpackChunkName: "EventPastDetails" */ '../pages/PageNotFound.vue')
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router
